module.exports = __webpack_public_path__ + "media/images/user/lp/mv/mobile-919f8cdf72b18154caa48ecd8c88804e.png";